import React from 'react';
import { connect } from 'react-redux';
import Modal from 'react-responsive-modal';
import { Form } from 'react-form';
import Translate from 'translate';
import Dropzone from "react-dropzone";
import async from 'async';
import ChannelCaseService from 'services/ChannelCaseService';
import { FormGroup, Select, Textarea } from 'components/FormElements/';
import { toggleAlertError, toggleLoading } from 'stores/actions/';
import { required } from 'constants/InputErrors';
import _ from 'lodash';
import IncmsService from 'services/IncmsService'


class AddRcssModal extends React.Component {
  constructor( props ) {
    super( props );

    this.state = {
      data: [],
      options: {}
    };

    this.submitForm = this.submitForm.bind( this );
  }

  componentWillReceiveProps( nextProps ) {
    if ( !this.props.open && nextProps.open ) {
      this.getData()
    }
  }

  getData() {
    
    this.props.toggleLoading( true );
    console.log( this.props.externalCodes );
    if (this.props.externalCodes){

      IncmsService.getRccsData().then( ( response ) => {
        if ( response.data ) {
          this.setState( {
            options: {
              groups: response.data.complaintClassList,
              types: response.data.complaintTypeList
            }
          } )
        }
        this.props.toggleLoading( false );
      } )

    }  
    else {
      const { contractMask } = this.props.activeAccount.incmsDataobj;
      IncmsService.getRccsGroup( contractMask ).then( ( response ) => {
        if ( response.data ) {
          // console.log(response.data);
          this.setState( {
            options: {
              groups: response.data ,
              //types: response.data.complaintTypeList
            }
          } )
        }
        this.props.toggleLoading( false );
      } )
    }
  }

  submitForm( data ) {
    const { channel, onClose, onReloadData, toggleAlertError, toggleLoading, externalCodes, locale } = this.props;

    const referenceTanslate = locale == 'en' ? 'RCCS Reference' : locale == 'es' ? 'Referencia PQRS' : 'RCCS Referência';

    if (!externalCodes){
      const objGroup = _.filter( this.state.options.groups, { id: data.rccsGroup } );
      const objType = _.filter( this.state.options.filteredTypes, { id: data.rccsType } );
      // console.log(" grupo ", objGroup);
      // console.log(" types ", objType);
      data.rccsGroupDescription = objGroup[0].description;
      data.rccsTypeDescription = objType[0].description;
    }


    toggleLoading( true );

    data.channel = channel.id;
    data.typeCase = 'rccs';
    data.account = this.props.activeAccount.id;
    

    if( data.attachments ) {



      const reader = new FileReader();
      const attachments = [];
      async.eachSeries( data.attachments, ( file, nextFile ) => {
        reader.readAsDataURL( file );
        reader.onload = ( event ) => {
          attachments.push( {
            file: event.target.result,
            name: file.name
          } );
          nextFile()
        };
      }, ( error ) => {
        if( error ) return this.props.toggleAlertError( <Translate id="errorFileProcess"/> );
  
        ChannelCaseService.saveCase( { ...data, attachments } )
          .then( ( response ) => {
            toggleLoading( false );
            if ( response.errors ) return toggleAlertError( response.errors );
  
            toggleAlertError( `${referenceTanslate}: ${response.data.rccsReference || '---'}`,response.data.rccsReference );
            onReloadData();
            onClose()
          } )
      } )

      /*const reader = new FileReader();
      reader.readAsDataURL( data.attachment );
      reader.onload = ( event ) => {
        data.attachment = {
          file: event.target.result,
          name: data.attachment.name
        };

        ChannelCaseService.saveCase( data ).then( ( response ) => {
          toggleLoading( false );
          if ( response.errors ) return toggleAlertError( response.errors );
          toggleAlertError( `RCCS Reference: ${response.data.rccsReference || '---'}`,response.data.rccsReference );
          onReloadData();
          onClose()
        } )
      };*/

    } else {
      ChannelCaseService.saveCase( data ).then( ( response ) => {
        toggleLoading( false );
        if ( response.errors ) return toggleAlertError( response.errors );
        toggleAlertError( `${referenceTanslate}: ${response.data.rccsReference || '---'}`,response.data.rccsReference );
        onReloadData();
        onClose()
      } )
    }
  }

  filterTypesLec = ( group ) => {
    const {options} = this.state;
    const { contractMask } = this.props.activeAccount.incmsDataobj;
    this.props.toggleLoading( true );
    IncmsService.getRccsTypes( contractMask, group ).then( ( response ) => {
      if ( response.data ) {
        console.log(response.data);
        this.setState( {
          options: {
            groups: options.groups,
            filteredTypes: response.data
          }
        } )
      }
      this.props.toggleLoading( false );
    } )

  };

  filterTypes = ( group ) => {
    if( group ) {
      const types = _.filter( this.state.options.types, { codeClass: group } );
      this.setState( { options: { ...this.state.options, filteredTypes: types } } )
    } else {
      this.setState( { options: { ...this.state.options, filteredTypes: [] } } )
    }
  };

  render() {
    const { onClose, open, externalCodes } = this.props;

    return (
      <Modal closeOnEsc={false}
             little
             modalClassName="col-md-6"
             open={open}
             onClose={onClose}>
        <h5 className="mt-0"><Translate id="addRCCS"/></h5>

        <Form onSubmit={this.submitForm}
              validate={( values ) => {
                return {
                  rccsGroup: required( values.rccsGroup ),
                  rccsType: required( values.rccsType ),
                  registerComment: required( values.registerComment )
                }
              }}
        >
          {( { setValue, getValue, removeValue, submitForm } ) =>
            <form onSubmit={submitForm}>


              {externalCodes &&
              <div className="row">
                <FormGroup containerClass="col-md-6">
                  <label><Translate id="RCCSGroup"/></label>
                  <Select field="rccsGroup" className="form-control" placeholder=""
                          valueKey="codeClass" labelKey="descriptionClass"
                          onChange={(value) => {
                            setValue( 'rccsType', null );
                            this.filterTypes(value)
                          }}
                          options={this.state.options.groups}/>
                </FormGroup>

                <FormGroup containerClass="col-md-6">
                  <label><Translate id="RCCSType"/></label>
                  <Select field="rccsType" className="form-control" placeholder=""
                          valueKey="idComplaint" labelKey="descriptionType"
                          options={this.state.options.filteredTypes}/>
                </FormGroup>
              </div>
              }

              {!externalCodes &&
              <div className="row">
                <FormGroup containerClass="col-md-6">
                  <label><Translate id="RCCSGroup"/></label>
                  <Select field="rccsGroup" className="form-control" placeholder=""
                          valueKey="id" labelKey="description"
                          onChange={(value) => {
                            // setValue( 'rccsGroup', value );
                            setValue( 'rccsType', null );
                            this.filterTypesLec(value)
                          }}
                          options={this.state.options.groups}/>
                </FormGroup>

                <FormGroup containerClass="col-md-6">
                  <label><Translate id="RCCSType"/></label>
                  <Select field="rccsType" className="form-control" placeholder=""
                          valueKey="id" labelKey="description"
                          options={this.state.options.filteredTypes}/>
                </FormGroup>
              </div>
              }

              <FormGroup>
                <label><Translate id="comment"/></label>
                <Textarea field="registerComment" className="form-control" rows={5}/>
              </FormGroup>

              <Dropzone
                className="d-inline"
                accept="application/pdf, .doc, .docx, .xlsx, .xls, image/*"
                maxSize={5000000}
                multiple={true}
                onDrop={( files ) => setValue( 'attachments', getValue( 'attachments' ) ? getValue( 'attachments' ).concat( ...files ) : files )}>

                <i className="fa fa-paperclip mr-1"/>
                <span className="color-gray-4 pointer font-weight-light"><Translate id="AttachFile"/></span>
              </Dropzone>

              <div className="col-md-12 send-email-new-files">
                      {_.map( getValue( 'attachments' ), ( file, index ) =>
                        <div key={index}
                             className="callout callout-info mx-0 my-2 p-2 d-flex justify-content-between">
                          {file.name}
                          <i className="fa fa-close pointer"
                             onClick={() => removeValue( 'attachments', index )}/>
                        </div>
                      )}
              </div>

              <div className="text-right">
                <button className="btn btn-info"><Translate id="submit"/></button>
              </div>
            </form>
          }
        </Form>
      </Modal>
    )
  }
}


const mapStateToProps = ( state, ownProps ) => ( {
  externalCodes: state.settings.externalCodes,
  externalCustomer: state.settings.externalCustomer,
  locale: state.settings.locale.locale,
} );

const mapDispatchToProps = dispatch => ({
  toggleAlertError: ( message, msgToCopy ) => {
    dispatch( toggleAlertError( message, msgToCopy ) );
  },
  toggleLoading: ( isLoading ) => {
    dispatch( toggleLoading( isLoading ) );
  },
});

export default connect( mapStateToProps, mapDispatchToProps )( AddRcssModal );





// WEBPACK FOOTER //
// ./routes/app/components/Agent/AddRccsModal/index.js